import _ from 'lodash';
import Sortable from 'sortablejs';
import HSAccordion from "@preline/accordion";
import HSTreeView from "@preline/tree-view";
import gsap from "gsap";

document.addEventListener('DOMContentLoaded', () => {
	(function () {
		const columns = Array.from(document.querySelectorAll('[data-move]'));
		if (columns.length !== 2) return;

		const [colA, colB] = columns;
		const parent = colA.parentElement;

		const parentHeight = parent.offsetHeight;
		const colAHeight = colA.scrollHeight;
		const colBHeight = colB.scrollHeight;

		// Overshoot: half first image height or 50px
		const firstAImg = colA.querySelector('img');
		const firstBImg = colB.querySelector('img');
		const overshootA = firstAImg ? firstAImg.offsetHeight / 2 : 50;
		const overshootB = firstBImg ? firstBImg.offsetHeight / 2 : 50;

		// For A: scroll from start (overshoot, fully visible at top) to end (overshoot, fully visible at bottom)
		const aStart = overshootA;
		const aEnd = -Math.max(0, colAHeight - parentHeight) - overshootA;

		// For B: scroll from end to start (opposite direction of A)
		const bStart = overshootB;
		const bEnd = -Math.max(0, colBHeight - parentHeight) - overshootB;

		const duration = 40; // seconds

		// Column A: normal (top to bottom, yoyo back)
		gsap.fromTo(colA,
			{ y: aStart },
			{
				y: aEnd,
				duration: duration,
				ease: "sine.inOut",
				repeat: -1,
				yoyo: true
			}
		);

		// Column B: reversed (bottom to top, yoyo back)
		gsap.fromTo(colB,
			{ y: bEnd },    // Start at the bottom-most position
			{
				y: bStart,    // Move to the top-most position
				duration: duration,
				ease: "sine.inOut",
				repeat: -1,
				yoyo: true
			}
		);
	})();

	(function () {
		HSTreeView.autoInit();
		HSAccordion.autoInit();

		const draggable = document.querySelectorAll('[data-hs-nested-draggable]');

		draggable.forEach((el) => {
			const options = {
				group: 'nested',
				animation: 150,
				fallbackOnBody: true,
				swapThreshold: 0.65,
				ghostClass: 'dragged',
				onEnd: (evt) => {
					const { item } = evt;

					if (item.classList.contains('hs-accordion')) {
						let existingInstance = HSAccordion.getInstance(item, true);
						let updatedInstance;

						existingInstance.element.update();
						updatedInstance = HSAccordion.getInstance(item, true);
						window.$hsAccordionCollection.map((el) => {
							if (
								el.element.el !== existingInstance.element.el &&
								el.element.group === existingInstance.element.group &&
								el.element.el.closest('.hs-accordion-group') &&
								el.element.el.classList.contains('active') &&
								existingInstance.element.el.classList.contains('active')
							) el.element.hide();

							return el;
						});
					}

					if (!!item.hasAttribute('data-hs-tree-view-item')) {
						const treeViewItem = HSTreeView.getInstance(item.closest('[data-hs-tree-view]'), true);

						treeViewItem.element.update();
					}
				},
			};
			const data = el.getAttribute('data-hs-nested-draggable');
			const dataOptions = data ? JSON.parse(data) : {};
			const sortable = new Sortable(el, _.merge(options, dataOptions));
		});
	})();

	// Close Drawer function
	function closeDrawer() {
		backdrop.classList.remove('opacity-100');
		backdrop.classList.add('opacity-0');
		slidePanel.classList.remove('translate-x-0');
		slidePanel.classList.add('-translate-x-full');
		document.body.style.overflow = '';

		// Wait for transition, then hide
		setTimeout(() => {
			drawer.classList.add('hidden');
			openBtn.focus();
		}, 500); // match transition duration
	}

	// Close Suggest SR Norms on click outside
	document.addEventListener('click', (event) => {
		const suggestNorms = document.querySelector('#suggest_sr_norms');
		if (suggestNorms && !suggestNorms.contains(event.target)) {
			suggestNorms.classList.add('hidden');
			suggestNorms.style.visibility = 'hidden';
		}
	});

	const openBtn = document.getElementById('open-drawer');
	const drawer = document.getElementById('drawer');
	const allDatepickers = document.querySelectorAll('.datepicker');
	const notifications = document.querySelectorAll('.notification');

	notifications.forEach((notification) => {
		const closeButton = notification.querySelector('.close');
		if (closeButton) {
			closeButton.addEventListener('click', () => {
				notification.classList.add('hidden');
			});
		}
	});

	allDatepickers.forEach((datepickerElement) => {
		// Initialize datepicker for each element
		new Datepicker(datepickerElement, {
			autohide: true,
			format: 'yyyy-mm-dd',
			maxDate: new Date(),
			minDate: new Date('2000-01-01'),
		});
	});

	if(openBtn || drawer) {

		const closeBtn = document.getElementById('close-drawer');
		const backdrop = drawer.querySelector('[aria-hidden="true"]');
		const slidePanel = drawer.querySelector('.slider');

		// Open Drawer
		openBtn.addEventListener('click', () => {
			drawer.classList.remove('hidden');
			requestAnimationFrame(() => {
				backdrop.classList.add('opacity-100');
				backdrop.classList.remove('opacity-0');
				slidePanel.classList.remove('translate-x-full');
				slidePanel.classList.add('translate-x-0');
				// Optional: focus trap
				closeBtn.focus();
			});
			document.body.style.overflow = 'hidden'; // prevent background scroll
		});

		// Click backdrop or close btn
		backdrop.addEventListener('click', closeDrawer);
		closeBtn.addEventListener('click', closeDrawer);

		// Optional: Escape closes
		drawer.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') closeDrawer();
		});

	}
});
